import { createFileRoute } from "@tanstack/react-router";
import { Entscheidung } from "../../features/shell/Entscheidung";

export const Route = createFileRoute("/entscheidung/$vergleichId")({
  component: EntscheidungRoute,
});

function EntscheidungRoute() {
  const { vergleichId } = Route.useParams();
  return <Entscheidung vergleichId={vergleichId} />;
}
